const storedToken = localStorage.getItem('accessToken');
const storedUser = localStorage.getItem('user');

const user = storedUser ? JSON.parse(storedUser) : null

const initialState = {
  user,
  accessToken: storedToken,
  isAuthenticated: !!user,
};

const authReducer = (state = initialState, action) => {
  const reducers = {
    'LOGIN': () => {
      const { accessToken, user } = action.payload
 
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('accessTokenExpireAt', user.accessTokenExpireAt);
      localStorage.setItem('refreshToken', user.refreshToken);
      localStorage.setItem('refreshTokenExpireAt', user.refreshTokenExpireAt);
      localStorage.setItem('rolePermissions', JSON.stringify(user.rolePermissions));
      localStorage.setItem('user', JSON.stringify(user.userInfo));
      localStorage.setItem('roles', JSON.stringify(user.roles));
      return {
        ...state,
        accessToken,
        user,
        isAuthenticated: true,
      };
    },
    'LOGOUT': () => {
      localStorage.clear()
      return {
        ...state,
        accessToken: '',
        user: null,
        isAuthenticated: false,
      };
    },
  }

  return reducers[action.type] ? reducers[action.type]() : state
};

export default authReducer